import { render, staticRenderFns } from "./Banner_button.vue?vue&type=template&id=ddcf0410&scoped=true&"
import script from "./Banner_button.vue?vue&type=script&lang=js&"
export * from "./Banner_button.vue?vue&type=script&lang=js&"
import style0 from "./Banner_button.vue?vue&type=style&index=0&id=ddcf0410&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddcf0410",
  null
  
)

export default component.exports